import React from 'react';
import { useLiveFeed } from './live/LiveFeedProvider';
import TickerNumber from './live/TickerNumber';
import SplitFlap from './live/SplitFlap';

// Deterministic pseudo-random hash from a stage id, 0..max.
const hashStage = (id) => {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return h;
};

const stageRework = (stageId) => (hashStage(stageId) % 6) + 1; // 1..6 %

const StageStatStrip = ({ stage, vehicles, currentTime }) => {
  const { throughputPerMin, wipAgeP90Mins } = useLiveFeed();

  const thruMultiplier = 0.5 + ((hashStage(stage.id) % 11) / 10); // 0.5..1.5
  const stageThruPerHour =
    Math.round((throughputPerMin[throughputPerMin.length - 1] ?? 0) * thruMultiplier * 60 * 10) / 10;

  const avgDwellMin =
    vehicles.length === 0
      ? 0
      : Math.round(
          vehicles.reduce((acc, v) => {
            const mins = (new Date(currentTime).getTime() - new Date(v.entryTime).getTime()) / 60000;
            return acc + mins;
          }, 0) / vehicles.length
        );

  const revInStage = vehicles.reduce((acc, v) => acc + (v.revenue || 0), 0);
  const techOnStage = new Set(vehicles.map((v) => v.technician)).size;
  const wipP90 = wipAgeP90Mins[wipAgeP90Mins.length - 1] ?? 0;
  const rework = stageRework(stage.id);

  return (
    <div className="px-3 py-2 border-b border-white/10 bg-white/[0.02] font-mono-tech text-[9px] tracking-wide text-neutral-400">
      <div className="flex justify-between items-center mb-1">
        <span>
          THRU <TickerNumber value={Math.round(stageThruPerHour * 10)} digits={3} />/h
        </span>
        <span>DWELL {avgDwellMin}m</span>
        <span>
          R <TickerNumber value={revInStage} digits={5} />
        </span>
      </div>
      <div className="flex justify-between items-center text-neutral-500">
        <span>
          TECH <SplitFlap text={String(techOnStage).padStart(2, '0')} width={2} />
        </span>
        <span>P90 {wipP90}m</span>
        <span>RWK {rework}%</span>
      </div>
    </div>
  );
};

export default StageStatStrip;
